import React from 'react';

import Fade from '@mui/material/Fade';

import TracklogMapControls from 'ff/debrief/components/map/TracklogMapControls';
import ErrorBar from 'ff/debrief/components/ErrorBar';
import InfoSidebar from 'ff/debrief/components/debriefSidebar/InfoSidebar';
import Timeline from 'ff/debrief/components/timeline';
import SegmentDetails from 'ff/debrief/components/scoringDetails/SegmentDetails';
import MapAreaGrid from 'ff/debrief/layouts/MapAreaGrid';
import OwnshipMapLayer from 'ff/debrief/components/map/OwnshipMapLayer';
import { useRouteContext, useDebriefApp, useChrono } from 'ff/debrief/hooks';

export const pathString = '/track/:tracklogId';

const LegacyShareRoute = () => {
    const { isChartOpen } = useDebriefApp();
    const { currentPoint } = useChrono();

    useRouteContext({
        page: 'LegacyShareView',
    });

    return (
        <>
            {currentPoint && (
                <OwnshipMapLayer
                    latitude={currentPoint?.latitude}
                    longitude={currentPoint?.longitude}
                    bearing={currentPoint?.bearing}
                />
            )}
            <MapAreaGrid>
                <TracklogMapControls />
                <InfoSidebar />
                <Timeline />
                <ErrorBar />
                <Fade in={isChartOpen} unmountOnExit>
                    <SegmentDetails />
                </Fade>
            </MapAreaGrid>
        </>
    );
};

export default LegacyShareRoute;
